import { useQueryClient } from '@tanstack/react-query';

import {
	CONTACT_PERSONS,
	FILTER_APPROVAL_USERS,
	ORGANISATION_PROFILE,
	ORGANIZATIONS_USERS_APPROVERS,
	USERS,
} from '@constants/queryKeys';

export const useInvalidateUsers = () => {
	const queryClient = useQueryClient();

	const invalidateUsers = () => {
		return [
			queryClient.invalidateQueries([USERS]),
			queryClient.invalidateQueries([ORGANISATION_PROFILE]),
			queryClient.invalidateQueries([CONTACT_PERSONS]),
			queryClient.invalidateQueries([FILTER_APPROVAL_USERS]),
			queryClient.invalidateQueries([ORGANIZATIONS_USERS_APPROVERS]),
		];
	};

	return {
		invalidateUsers,
	};
};
